export default {
  setString(text: string) {
    return navigator.clipboard?.writeText(text)
  },
  getString: async () => navigator.clipboard?.readText() || "",
}
